import { Injectable, NgZone } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { UserService } from '../user/user.service';
import { LOCAL_STORAGE_KEYS, LocalStorageService } from '../local-storage.service';
import { CLIENT_REDIRECT_AFTER_AUTH_ROUTES } from 'src/app/shared/constants';
import { NavigateAfterLoginService } from '../navigate-after-login.service';
import { NativeCheckService } from '../native-check.service';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  public constructor(
    private userService: UserService,
    private router: Router,
    private zone: NgZone,
    private localStorageService: LocalStorageService,
    private navigateAfterLoginService: NavigateAfterLoginService,
    private nativeCheckService: NativeCheckService,
  ) { }

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    if(!this.userService.loggedUser && CLIENT_REDIRECT_AFTER_AUTH_ROUTES.some(term => state.url.includes(term))) {
      // redirect on succesful auth
      this.navigateAfterLoginService.saveRouteAndAuth(state.url);
    } else if (!this.userService.loggedUser && !this.localStorageService.getItemSync({key: LOCAL_STORAGE_KEYS.USER_LOCAL_STORAGE_KEY})) {
      if(this.nativeCheckService.isNativePlatform()) {
        this.zone.run(() => {
          this.router.navigate(['/login']);
        });
      } else {
        this.router.navigate(['/login']);
      }
      return false;
    }

    return true;
  }
}
